export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 10_07.98e67f35.jpg";